import React, { useEffect, useState } from 'react';
import { API_ENDPOINTS, SITE_URL, toAbsoluteUrl } from '../../assets/helpers/AssetHelpers';
import './subcontent.css';
import { Link } from 'react-router-dom';
import useReRouteHook from '../../assets/hooks/useReRouteHook';
import { CmsContent } from '../../types/types';
import { getCMSContent } from '../../services/api/Api';
import JainamLoader, { loaderMessages } from '../common/JainamLoader/JainamLoader';

const SubContent = ({ filteredCategory, category_name, child_category_name, index, isLast }: any) => {
	const [filteredData, setFilteredData] = useState<CmsContent[]>([]);
	const [showImage, setShowImage] = useState(false);
	const [loading, setLoading] = useState(false);
	const { reRouteButtonRenderer } = useReRouteHook();

	const handleButtonClick = async (category: string) => {
		setLoading(true);
		try {
			const fetchedData = await getCMSContent(`cms_category=${category}`)

			if (fetchedData.data) {
				const filtered = fetchedData.data
					.filter((item: { cms_category: string }) => item.cms_category === category)
					.sort((a: CmsContent, b: CmsContent) => {
						const orderA = a.sorting_order === 0 ? Number.MAX_SAFE_INTEGER : a.sorting_order;
						const orderB = b.sorting_order === 0 ? Number.MAX_SAFE_INTEGER : b.sorting_order;
						return orderA - orderB;
					});

				setFilteredData(filtered);
				setLoading(false);
			} else {
				console.error('Unexpected data format:', fetchedData);
				setLoading(false);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
			setLoading(false);
		}
	};

	useEffect(() => {
		if (index === 0 && filteredCategory?.category_name) {
			handleButtonClick(filteredCategory.category_name);
		}
	}, [filteredCategory?.category_name, index]);

	const isFirstAccordion = index === 0;

	return (
		<>
			<div
				className={`subContent-accordion_item accordion-item `}
				key={index}
				style={{ border: 'none' }}>
				<h2 className="subContent-accordion_header accordion-header text-justify in_semi">
					<button
						className={`subContent-accordion_button accordion_button_after  b1 accordion-button ${isFirstAccordion ? '' : 'collapsed'} subContent-head fs-18 p-3 sub-c-sub-style link-hover ${isLast ? '' : 'border-bottom'}`}
						style={{
							border: 'none',
							boxShadow: 'none',
							padding: '15px 0px',
						}}
						type="button"
						onClick={() => handleButtonClick(filteredCategory?.category_name)}
						data-bs-toggle="collapse"
						data-bs-target={`#subContentCollapse${index}`}
						aria-expanded={isFirstAccordion ? 'true' : 'false'}
						aria-controls={`subContentCollapse${index}`}>
						{filteredCategory?.category_name}
					</button>
				</h2>
				<div
					id={`subContentCollapse${index}`}
					className={`subContent-accordion_collapse accordion-collapse collapse ${isFirstAccordion ? 'show' : ''} border-bottom`}
					data-bs-parent="#subContent"
				>
					<div className="p-3 order-accordion-body">
						{loading ? (
							<JainamLoader variant="section" messages={loaderMessages.faqs} />
						) : filteredData && filteredData.length > 0 ? (
							<ol className="d-flex flex-column gap-3 list-group-numbered mb-0 mb-md-1 p-0">
								{filteredData.map((subItem: CmsContent, subIndex: number) => (
									<li className="fs-16 list-group-item d-flex gap-1 align-items-baseline " key={subIndex}>
										{reRouteButtonRenderer({
											url: `/category/${encodeURIComponent(category_name)}/${encodeURIComponent(
												child_category_name,
											)}/${encodeURIComponent(filteredCategory?.new_id)}/${encodeURIComponent(
												subItem?.id,
											)}`,
											classes: `color1 cursor-pointer in_med subcategory-hover p-0 fs-16`,
											nameText: subItem.title.trim(),
											spanClasses: 'color1 subcategory-hover',
										})}
									</li>
								))}
							</ol>
						) : (
							<div className="border-0 text-center">
								{showImage && (
									<img
										src={toAbsoluteUrl('about-section/no-faq.svg')}
										alt="no_data_found"
										style={{ width: '200px' }}
									/>
								)}
								<p className="fs-6 py-2 bw_semi">There are no questions</p>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default SubContent;
